import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';

@inject(AuthService, Router)
export class TimeArea {
    constructor(authService, router) {

        this.authService = authService;

        console.log("user account top menu:")
        console.log(this.authService.getAccount());
        this.org_name = this.authService.getAccount().org_name;
        
        this.offset = new Date().getTimezoneOffset();
        if(this.offset<0)
        this.offset = "GMT +"+this.offset/-60;
        else
        this.offset = "GMT -"+this.offset/60;

        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var date = new Date();
        var h = date.getHours();
        var m = date.getMinutes();
        var session = "AM"; 
        
        //conditions for times behavior 
        if ( h == 0 ) {
        h = 12;
        }
        if( h >= 12 ){
        session = "PM";
        }
        
        if ( h > 12 ){
        h = h - 12;
        }
        m = ( m < 10 ) ? m = "0" + m : m;
        this.current_time = h + ":" + m + " " + session;
    }
    activate() { }
    detached() { }
    load() { }
}
